import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryTermDefinitionText({definition, search, highlight}) {
    // Used in

    // BUILD
    if (isNullOrUndefined(definition))
        return null
    return (
        <div dangerouslySetInnerHTML={{ __html: highlight(definition, search) }} />
    );
}